import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import BadgeUI from '../../../widgets/output/BadgeUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'


const ClientTransactionListUI = ({ context, txnList,
  onCopyToClipboard, copyToClipboardText,
  hasMore, onMoreTransactions, gettingMore,
  onUpdateClick, onDeduplicateClick, deduplicateSuccessMessage, deduplicateErrorList
}) =>
  <div className='txns'>
    <div className='g_text_right g_m_bottom_50'>
      <span className='g_flex_h'>
        <span className='g_flex_h'>
          <ButtonTinyWithSpinnerUI className='g_m_right_100' label='Deduplicate' spinnerOnLeft={false}
            onClick={onDeduplicateClick} successMsg={deduplicateSuccessMessage}
            errorList={deduplicateErrorList}
          />
        </span>
        {
          hasMore &&
          <span className='g_flex_h g_flex_right'>
            {txnList.length} transaction{txnList.length == 1 ? '' : 's'} displayed
            <LinkWithSpinnerUI className='g_m_left_100' label='Get more' spinnerOnLeft={false}
              onClick={onMoreTransactions} busy={gettingMore}
            />
          </span>
        }
        {
          !hasMore &&
          <>{txnList.length} transaction{txnList.length == 1 ? '' : 's'} displayed</>
        }
      </span>
    </div>

    <table>
      <thead className='g_small'>
        <tr>
          <th>Date</th>
          <th>Details</th>
          <th>Credit</th>
          <th>Debit</th>
          <th>Balance</th>
        </tr>
      </thead>
      <tbody>
        {
          txnList.map((txn, i) =>
            <TxnRowUI key={i} context={context} txn={txn}
              onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
              onUpdateClick={onUpdateClick}
            />
          )
        }
      </tbody>
    </table>
  </div>

const TxnRowUI= ({ txn, onCopyToClipboard, copyToClipboardText, onUpdateClick }) =>
  <tr className='g_small'>
    <td className='g_text_top g_small'>
      <span className='g_no_wrap_2'>{txn.transactionDateF}</span>
    </td>
    <td className='g_text_top g_p_left_50 g_small'>
      <RowLeftUI txn={txn} onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText} />
    </td>
    <td className='g_text_top g_text_right g_p_left_50 g_small'>
      {
        txn.amount > 0 &&
        <span>{txn.amountF2}</span>
      }
    </td>
    <td className='g_text_top g_text_right g_p_left_50 g_small'>
      {
        txn.amount < 0 &&
        <span>({txn.amountF2})</span>
      }
    </td>
    <td className='g_text_top g_text_right g_p_left_50 g_small'>
      {txn.closingBalance < 0 ? `(${txn.closingBalanceF2})` : txn.closingBalanceF2}
    </td>
  </tr>

const RowLeftUI = ({ txn, onCopyToClipboard, copyToClipboardText }) =>
  <div className='g_flex_v'>
    <span className='g_small'>Narration: {txn.narration}</span>
    {
      txn.cheque &&
      <span className='g_small'>Cheque: {txn.cheque}</span>
    }
    <span className='g_small'>Category: {txn.paymentCategory}; Payment mode: {txn.paymentMode}</span>
    <span className='g_m_top_25 g_flex_h g_flex_left'>
      {
        txn.analyzerCategory &&
        <BadgeUI label={txn.analyzerCategoryLabel} />
      }
      {
        txn.manualAnalysis &&
        <span className='g_m_left_50 g_text_small g_muted'>
          (manual)
        </span>
      }
      {
        txn.matchedKeywords &&
        <span className='g_m_left_50'>
          <b>Matched keywords: {txn.matchedKeywords}</b>
        </span>
      }
    </span>
  </div>

export default ClientTransactionListUI
